var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"indicator",class:{ saved: !_vm.loading }},[_c('Icon',{attrs:{"name":_vm.loading ? 'loader' : 'complete'}}),_vm._v(_vm._s(_vm.loading ? 'Сохранение...' : 'Сохранено'))],1)}
var staticRenderFns = []

export { render, staticRenderFns }